import { TaggedUnion } from "type-fest";

export type IncomingMessage = SubscribeAckMessage;

export interface SubscribeMessage {
  M: "Subscribe";
  filter?: string;
  functionalBlockClass: string;
}

export interface UnsubscribeMessage {
  M: "Unsubscribe";
  SID: number;
}

export interface SubscribeAckMessage {
  M: "SubscribeAck";
  SID: number;
  Filter: string;
  FunctionalBlockClass: string;
}

export type App = keyof typeof App;
export const App = {
  AppU4DM: "AppU4DM",
  Task: "Task",
} as const;

export type TaskSignal =
  | "StatusChanged"
  | "ErrorCountChanged"
  | "MessageOnTaskReceived"
  | "TaskStatusChanged";

export type AppU4DMSignal =
  | "MaterialTrackingUnitDeactivationEvent"
  | "ScrewingExecuted"
  | "APPMain_GF_MarkingCompleted"
  | "ResultsCreatedOnTools"
  | "OnDisassemblyWorkOrderOperation"
  | "APPMain_GF_EngravingCompleted"
  | "APPMain_GF_MessageToHALPSent"
  | "APPMain_GF_PackingLabelPrinted"
  | "APPMain_GF_ProductsWaitingForValidation"
  | "APPMain_GF_OnStartProcessingMessageFromScanner"
  | "APPMain_GF_OnCompleteProcessingMessageFromScanner"
  | "StatusChanged"
  | "WorkOrderStatusChanged"
  | "OnSendBuyOffNotification"
  | "OnProducedMaterialItemDetached"
  | "NonConformanceNotificationSgn"
  | "ProcessNotificationSgn"
  | "WorkOrderNotificationSgn"
  | "SnagAndNoteNotificationSgn"
  | "NonProductiveActivityNotificationSgn"
  | "OnCompleteWorkOrder"
  | "OnCompleteWorkOrderOperation"
  | "OnCompleteWorkOrderOperationFullQty"
  | "OnCompleteWorkOrderOperationSerialized"
  | "OnCompleteWorkOrderOperationTransferBatch"
  | "OnStartWorkOrderOperationFullQty"
  | "OnStartWorkOrderOperationSerialized"
  | "OnStartWorkOrderOperationTransferBatch"
  | "OnJoinTeam"
  | "OnLeaveTeam"
  | "OnCompleteWorkOrderStepFullQty"
  | "OnCompleteWorkOrderStepSerialized"
  | "OnCompleteWorkOrderStepTransferBatch"
  | "OnStartWorkOrderStepSerialized"
  | "OnStartWorkOrderStepTransferBatch"
  | "OnStartWorkOrderStepFullQty"
  | "OnPrintingWorkOrder"
  | "OnPrintingWorkOrderOperation"
  | "OnPrintingWorkOrderStep"
  | "OnUsedToolSignal"
  | "OnAssemblyWorkOrderOperation"
  | "OnBufferSpecificContentThresholdValue"
  | "CompleteTransferEvent"
  | "StartTransferEvent"
  | "OnTransmitEquipmentSetPoint"
  | "CompletePJFGenerateFromPlaceholder"
  | "CreatedPrintJobFileFromPlaceHolder"
  | "OnCreateUserWoopAssociation"
  | "OnTransmitToolSetPoint"
  | "DNCStartTransferEvent"
  | "DNCCompleteTransferEvent"
  | "OnChangeWorkOrderStatusToEdit"
  | "ConfigurationKeyChanged"
  | "CoProductProduced"
  | "ByProductProduced"
  | "OnPauseWorkOrderOperation"
  | "OnResultCreation"
  | "OnSkipWOOperation"
  | "OnSubmittedResult"
  | "OnCreateBuyOff"
  | "OnSentenceBuyOff"
  | "LogisticRequestCreated"
  | "LogisticRequestStatusChanged"
  | "ExtEventLogFailureNotificationCreated"
  | "ExtEventLogFailureNotificationDeleted"
  | "OnSentenceChangeNonConformance"
  | "MaterialTrackingUnitActivationEvent"
  | "OnSentenceNonConformanceV3_1"
  | "ExecutionGroupStatusChanged"
  | "OnSetHoldWorkOrder"
  | "OnAbortWorkOrder"
  | "OnReleaseWorkOrder"
  | "WorkOrderQuantityScrapped"
  | "WorkOrderQuantityRemoved"
  | "WorkOrderSerialNumbersScrapped"
  | "ScrapMaterials";

interface Signals {
  Task: TaskSignal;
  AppU4DM: AppU4DMSignal;
}

export interface Signal<R = unknown> {
  _?: R;
  app: App;
  channel: Signals[App];
  filters?: string;
  enabled?: boolean;
}

export function signal<R extends Record<string, any>>(
  def: { filters?: string; enabled?: boolean } & TaggedUnion<
    "app",
    {
      [App.Task]: { channel: TaskSignal };
      [App.AppU4DM]: { channel: AppU4DMSignal };
    }
  >
): Signal<R> {
  return def;
}
